var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ADD_NOTIFICATIONS_DATA } from 'src/store/actions/notifications.actions';
var initialState = {
    data: null,
};
var notificationsReducer = function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case ADD_NOTIFICATIONS_DATA:
            return __assign(__assign({}, state), { data: payload.notifications.data });
        default:
            return state;
    }
};
export default notificationsReducer;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/notifications.reducers.ts
// module id = 1486
// module chunks = 81